import { Alerts, Brand, Neutrals, Theme } from './colors';

export const ColorTypography = {
  TextColorAccent: Brand.orange.Orange500,
  TextColorPrimary: Neutrals.neutralGreys.GreyNatural900,
  TextColorSecondary: Neutrals.neutralGreys.GreyNatural700,
  TextColorTertiary: Neutrals.neutralGreys.GreyNatural600,
  TextColorPlaceholder: Neutrals.neutralGreys.GreyNatural400,
  TextColorPromo: Brand.orange.Orange600,
  TextColorError: Alerts.Red500,
  TextColorInverted: Neutrals.main.White,
  TextColorInteractive: Theme.main.ThemeWater,
  TextColorDisabled: Neutrals.neutralGreys.GreyNatural300,
  TextColorOnDark: Neutrals.main.White,
};
